const IMAGE_URL_PATHNAME = /\.(avif|bmp|gif|ico|jpe?g|png|svg|webp)$/i;

export function isImageUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }
  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return false;
    }
    return IMAGE_URL_PATHNAME.test(url.pathname);
  } catch {
    return false;
  }
}
